import type { WsInboundEnvelope } from "./wsInboundEnvelope";
import {
  optCallerId,
  optString,
  optStringOrFiniteNumberString,
} from "./wsPayloadCoercion";

/** Queue row id / SIP leg id may arrive as string or finite number from the PBX gateway. */
function pickupCallId(raw: unknown): string | undefined {
  return optString(raw) ?? optStringOrFiniteNumberString(raw);
}

export interface PickupGroupCallRingingWsPayload {
  type: "pickup_group_call_ringing";
  call_id: string;
  caller_name?: string;
  caller_number?: string;
  ringing_extension?: string;
  ringing_user_name?: string;
}

export function parsePickupGroupCallRingingPayload(
  envelope: WsInboundEnvelope,
): PickupGroupCallRingingWsPayload | null {
  if (envelope.type !== "pickup_group_call_ringing") return null;
  const call_id = pickupCallId(envelope.call_id);
  if (!call_id) return null;
  const o = envelope;
  return {
    type: "pickup_group_call_ringing",
    call_id,
    caller_name: optString(o.caller_name),
    caller_number: optStringOrFiniteNumberString(o.caller_number),
    ringing_extension: optStringOrFiniteNumberString(o.ringing_extension),
    ringing_user_name: optString(o.ringing_user_name),
  };
}

export type PickupGroupCallLifecycleWsType =
  | "pickup_group_call_answered"
  | "pickup_group_call_ended";

export interface PickupGroupCallLifecycleWsPayload {
  type: PickupGroupCallLifecycleWsType;
  call_id: string;
}

export function parsePickupGroupCallLifecyclePayload(
  envelope: WsInboundEnvelope,
): PickupGroupCallLifecycleWsPayload | null {
  const t = envelope.type;
  if (t !== "pickup_group_call_answered" && t !== "pickup_group_call_ended") {
    return null;
  }
  const call_id = pickupCallId(envelope.call_id);
  if (!call_id) return null;
  return { type: t, call_id };
}

export interface PickupCallConfirmedWsPayload {
  type: "pickup_call_confirmed";
  call_id?: string;
  livekit_room?: string;
  room_name?: string;
  call_log_id?: string;
  provider_call_id?: string;
  caller_name?: string;
  caller_number?: string;
  original_target_user_id?: number;
}

export function parsePickupCallConfirmedPayload(
  envelope: WsInboundEnvelope,
): PickupCallConfirmedWsPayload | null {
  if (envelope.type !== "pickup_call_confirmed") return null;
  const o = envelope;
  return {
    type: "pickup_call_confirmed",
    call_id: pickupCallId(o.call_id),
    livekit_room: optString(o.livekit_room),
    room_name: optString(o.room_name),
    call_log_id: optString(o.call_log_id),
    provider_call_id: optString(o.provider_call_id),
    caller_name: optString(o.caller_name),
    caller_number: optStringOrFiniteNumberString(o.caller_number),
    original_target_user_id: optCallerId(o.original_target_user_id),
  };
}
